module.exports = __webpack_public_path__ + "img/icon-RequestControl-gray.b83e5d34.png";